import axios from 'axios';
import qs from 'qs';

export const createDailyChallenge = (data: any) =>
  axios.post('/api/v1/daily-challenges', data);

export const updateDailyChallengeById = ({
  dailyChallengeId,
  data,
}: {
  dailyChallengeId: string;
  data: any;
}) => axios.put(`/api/v1/daily-challenges/${dailyChallengeId}`, data);

export const getDailyChallenges = (params: Record<string, any>) =>
  axios.get(`/api/v1/daily-challenges?${qs.stringify(params)}`);

export const getDailyChallengeById = (dailyChallengeId: string) =>
  axios.get(`/api/v1/daily-challenges/${dailyChallengeId}`);

export const getDailyChallengesStats = () =>
  axios.get('/api/v1/daily-challenges/stats');

export const getDailyChallengeStats = (dailyChallengeId: string) =>
  axios.get(`/api/v1/daily-challenges/${dailyChallengeId}/stats`);

export const getDailyChallengeStatsByStudent = ({
  dailyChallengeId,
  studentId,
}: {
  dailyChallengeId: string;
  studentId: string;
}) =>
  axios.get(
    `/api/v1/daily-challenges/${dailyChallengeId}/stats/${studentId}`,
  );

export const removeDailyChallenge = (dailyChallengeId: string) =>
  axios.delete(`/api/v1/daily-challenges/${dailyChallengeId}`);

export const removeDailyChallengeStudents = (dailyChallengeId: string) =>
  axios.delete(
    `/api/v1/daily-challenges/${dailyChallengeId}/remove-students`,
  );

export const removeDailyChallengeLessons = (dailyChallengeId: string) =>
  axios.delete(`/api/v1/daily-challenges/${dailyChallengeId}/remove-lessons`);

export const removeDailyChallengeModules = (dailyChallengeId: string) =>
  axios.delete(`/api/v1/daily-challenges/${dailyChallengeId}/remove-modules`);
